/**
 * @file     useRentalsText.ts
 * @purpose  Client hook: `tr(key, vars)` over the active i18next language for
 *           the rentalsListing namespace, English default as fallback.
 */
'use client';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { translateRentals, type RentalsKey, type RentalsVars } from './copy';

export function useRentalsText(): (key: RentalsKey, vars?: RentalsVars) => string {
  const { t } = useTranslation();
  return useCallback(
    (key: RentalsKey, vars?: RentalsVars) => translateRentals((k, o) => String(t(k, o)), key, vars),
    [t],
  );
}
